import { render } from "./SwitchField.vue?vue&type=template&id=1770f5fc"
import script from "./SwitchField.vue?vue&type=script&lang=js"
export * from "./SwitchField.vue?vue&type=script&lang=js"

import "./SwitchField.vue?vue&type=style&index=0&id=1770f5fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__